<template>
  <div id="app">
    <header class="navbar" style="height: 60px;background-color: rgba(8,92,152,0.99);;color: rgba(250,250,250,0.99);border-bottom: 2px solid rgba(0,0,0,0.07);">
    <div style="position: fixed;left: 10px;top:5px;">
<!--      <img src="http://tmliang.cn/pic/jjm/slv3/logo.png" style="width: 50px;height: 50px;margin-right: 30px;">-->
      <img :src="img_logo" style="width: 50px;height: 50px;margin-right: 30px;">
      <b >CME-KGDTI</b> <span style="font-size: 16px;margin-top: 10px;margin-right: 80px"></span>
    </div>

      <nav class="nav" style="z-index: 998;">
        <ul>
          <li><a href="#/home" ><i class="fas fa-home"></i></a></li>
          <li><a href="#/sl" >SL Network</a></li>
          <li><a href="https://www.tmliang.cn/cluster/" target="_blank">CMCS</a></li>
          <li><a href="#/omics" >Omics Tool</a></li>
<!--          <li><a href="#/help" >Help</a></li>-->
          <li><a href="#/contact" >Contact Us</a></li>
        </ul>
      </nav>

    </header>

    <div id="appmain" style="margin-bottom:100px ">
      <router-view />
    </div>

    <!--    注脚-->
    <footer class="footer" style="margin-top: 10px">
      <div class="copyright">
        <p>Copyright &copy; Guo Lab, State Key Laboratory of Organic Electronics and Information Displays & Institute of Advanced Materials (IAM), Nanjing University of Posts & Telecommunications, Nanjing, China</p>
        <p>Liang Lab, College of Life Science, Nanjing Normal University, Nanjing, China</p>
      </div>
      <div class="icp">
<!--        网站访问次数-->
<!--        <VisitCounter></VisitCounter>-->
        <p>&copy; All rights reserved. ICP9036104</p>
      </div>
    </footer>
  </div>
</template>

<script>

import Datebase from "../views/DataBase";
import {serverIP} from "../../public/config";


export default {
  name: 'App',
  data() {
    return {
      serverIP:serverIP,
      img_logo: "/cluster-http/pic/jjm/slv3/logo.webp",

    };
  },
  methods:{

  },
  mounted() {

  }

}
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
#appmain{
  flex: 1; /* 使主内容区占满剩余空间 */
  margin-top: 95px; /* 将页面内容下移，避免导航栏遮挡内容 */
}
/*导航栏*/
.navbar {
  background: linear-gradient(90deg, rgba(15, 87, 25, 0.74), rgba(76, 203, 25, 0.35));
  backdrop-filter: blur(6px); /* 毛玻璃效果 */
  -webkit-backdrop-filter: blur(6px);
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  font: 30px/60px "heiti";
  padding: 0 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-bottom: 1.5px solid rgba(255, 255, 255, 0.1);
}


 body {
   margin: 0;
   font-family: 'Segoe UI', 'Helvetica Neue', sans-serif;
   background-color: #ffffff;
   color: #1f2d1f;
 }

.logo-area {
  display: flex;
  align-items: center;
}

.logo {
  height: 48px;
  margin-right: 14px;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.2));
}

.logo-title {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #e4ffdd;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
}

.nav ul {
  list-style: none;
  display: flex;
  gap: 36px;
  margin: 0;
  padding: 0;
}

.nav a {
  text-decoration: none;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  transition: all 0.25s ease;
}

.nav a:hover {
  color: #b4efc1;
  border-bottom: 2px solid #b4efc1;
}

#main-content {
  padding: 80px 24px 120px;
  max-width: 1200px;
  margin: 0 auto;
}

.footer {
  /*position: fixed;*/
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(10, 61, 44, 0.93);
  padding: 10px;
  text-align: center;
  font-size: 14px;
  color: white;

}


</style>




// WEBPACK FOOTER //
// src/router/App.vue